module.exports = __webpack_public_path__ + "img/Vorschau_2180x840_01.0b3b3885.jpg";